module.exports = __webpack_public_path__ + "img/image2.8b7b57bc.jpeg";